import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";

import Homepage from "./pages/homepage";
import About from "./pages/about";
import Projects from "./pages/projects";
import Articles from "./pages/articles";
import ReadArticle from "./pages/readArticle";
import Services from "./pages/services";
import AdSpaces from "./pages/adSpaces";
import Contact from "./pages/contact";
import PrivacyPolicy from "./pages/privacyPolicy";
import TermsOfService from "./pages/termsOfService";
import CommercialLaw from "./pages/commercialLaw";
import Disclaimer from "./pages/disclaimer";
import Notfound from "./pages/404";

import { TRACKING_ID } from "./data/tracking";
import GlobalStyles from "./GlobalStyles";
import { ThemeProvider, useTheme } from "./contexts/ThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";

const AppContent: React.FC = () => {
	const { theme } = useTheme();
	const location = useLocation();
	const analyticsEnabled = process.env.NODE_ENV === "production" && TRACKING_ID !== "";

	useEffect(() => {
		if (analyticsEnabled) {
			ReactGA.initialize(TRACKING_ID, {
				gtagOptions: { send_page_view: false },
			});
		}
	}, [analyticsEnabled]);

	useEffect(() => {
		if (analyticsEnabled) {
			ReactGA.send({
				hitType: "pageview",
				page: `${location.pathname}${location.search}`,
			});
		}
	}, [analyticsEnabled, location.pathname, location.search]);

	return (
		<EmotionThemeProvider theme={theme}>
			<GlobalStyles />
			<div className="App">
				<Routes>
					<Route path="/" element={<Homepage />} />
					<Route path="/about" element={<About />} />
					<Route path="/projects" element={<Projects />} />
					<Route path="/articles" element={<Articles />} />
					<Route path="/article/:slug" element={<ReadArticle />} />
					<Route path="/services" element={<Services />} />
					<Route path="/services/ad-spaces" element={<AdSpaces />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
					<Route path="/legal/terms-of-service" element={<TermsOfService />} />
					<Route path="/legal/commercial-law" element={<CommercialLaw />} />
					<Route path="/legal/disclaimer" element={<Disclaimer />} />
					<Route path="*" element={<Notfound />} />
				</Routes>
			</div>
		</EmotionThemeProvider>
	);
};

const App: React.FC = () => {
	return (
		<ThemeProvider>
			<LanguageProvider>
				<AppContent />
			</LanguageProvider>
		</ThemeProvider>
	);
};

export default App;
